/* eslint-disable no-unused-vars */
const moment = require('moment');

export default () => {
  function dateWithSuffix(date) {
    return moment(date).format('MMMM Do, YYYY');
  }
  window.addEventListener('load', () => {
    const dateElements = document.querySelectorAll('.date-with-suffix');
    dateElements.forEach((dateElement) => {
      const date = dateElement.innerHTML;
      dateElement.innerHTML = dateWithSuffix(date);
    });
  });
  const filterButton = document.querySelector('#selectDropdownButton');
  if (!filterButton) {
    return;
  }
  filterButton.addEventListener('click', () => {
    document.querySelector('#selectContent').classList.toggle('opacity-0');
  });
};
